module.exports = __webpack_public_path__ + "static/media/oberflex-tineo-2560x1440.2d3b5bc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-tineo-2560x1440.jpg
// module id = 1061
// module chunks = 37